exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trix_container{max-width:100%;height:auto}.trix_container .trix-button-group,.trix_container .trix-content{background-color:#fff}", ""]);

// exports
